import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TokenListValidCell } from './token-list-valid.cell';
import { TokenListValidHeader } from './token-list-valid.header';

export const TokenListValidColumn: IdentifiedColumnDef<
  GatewayTokenModel,
  GatewayTokenModel['valid']
> = {
  enableSorting: false,
  header: TokenListValidHeader,
  cell: TokenListValidCell,
};
